import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ApiService} from '../../api.service';


@Component({
    selector: 'app-view-note',
    templateUrl: './view-note.component.html',
    styleUrls: ['./view-note.component.css']
})
export class ViewNoteComponent implements OnInit {
    state: string;
    note: any;
    private id: any;

    constructor(protected route: ActivatedRoute, protected apiService: ApiService) {
    }

    ngOnInit() {
        const id = this.route.snapshot.paramMap.get('id');
        this.id = id;
        this.state = 'loading';
        this.loadNote();
    }
    loadNote() {
        this.apiService.getById('notes', this.id).subscribe(
            (value) => {
                this.note = value;
                this.state = '';
            }, (error) => {
                this.state = '';
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/notes/view-note/view-note.component.ts